import * as React from "react";

const SvgTakeTourIcon = (props) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M18.427 7a2 2 0 0 0 1.06-.304l2.156-1.348a1 1 0 0 0 0-1.696l-2.157-1.348A2 2 0 0 0 18.427 2H11a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h7.427ZM18.427 17a2 2 0 0 0 1.06-.304l2.156-1.348a1 1 0 0 0 0-1.696l-2.157-1.348a2 2 0 0 0-1.06-.304H11a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h7.427Z"
            fill="currentColor"
            fillOpacity={0.6}
        />
        <path
            d="M5.574 12a2 2 0 0 1-1.06-.304l-2.157-1.348a1 1 0 0 1 0-1.696l2.157-1.348A2 2 0 0 1 5.574 7H13a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H5.574ZM10 18a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3Z"
            fill="currentColor"
        />
    </svg>
);

export default SvgTakeTourIcon;
